import { apiFetch, buildQueryString } from './client';
import type { ListQueryParams } from '@lognai/frontend-core';
import type { AccessObject } from '@lognai/plugin-sdk';

export interface AccessObjectFilter {
  category?: string;
  scope?: string;
  pluginId?: string;
  isSystem?: boolean;
  search?: string;
}

export type AccessObjectFilters = ListQueryParams<AccessObjectFilter>;

export interface AccessObjectCreateInput {
  code: string;
  name: string;
  description?: string;
  category: string;
  scope: string;
  isConditional?: boolean;
  conditions?: unknown;
  pluginId?: string;
}

export interface AccessObjectUpdateInput {
  code?: string;
  name?: string;
  description?: string;
  category?: string;
  scope?: string;
  isConditional?: boolean;
  conditions?: unknown;
  isActive?: boolean;
}

const BASE_URL = '/api/admin/access-objects';

export const accessObjectsService = {
  list: async (filters?: AccessObjectFilters): Promise<AccessObject[]> => {
    const query = buildQueryString(filters as Record<string, unknown>);
    return apiFetch<AccessObject[]>(`${BASE_URL}${query}`);
  },

  getById: async (id: string): Promise<AccessObject> => {
    return apiFetch<AccessObject>(`${BASE_URL}/${id}`);
  },

  getSystemAccessObjects: async (): Promise<AccessObject[]> => {
    return apiFetch<AccessObject[]>(`${BASE_URL}?isSystem=true`);
  },

  create: async (data: AccessObjectCreateInput): Promise<AccessObject> => {
    return apiFetch<AccessObject>(BASE_URL, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  update: async (id: string, data: AccessObjectUpdateInput): Promise<AccessObject> => {
    return apiFetch<AccessObject>(`${BASE_URL}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  delete: async (id: string): Promise<void> => {
    return apiFetch<void>(`${BASE_URL}/${id}`, { method: 'DELETE' });
  },
};
